import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import fetcher from "../../../../dataProvider";
import {
  Link,
  Box,
  Typography,
  List,
  ListItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import moment from "moment";
import useCountDown from "../../../../hooks/useCountDown";

const useStyles = makeStyles((theme) => ({
  todayPoll: {
    position: "relative",
    display: "block",
    padding: "20px 0",
    borderRadius: "10px",
    "& h2": {
      fontSize: "20px",
      fontWeight: "600",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "10px",
    },
    "@media(max-width:480px)": {
      maxWidth: "100%",
      margin: "0",
    },
  },

  musicPlayer: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "6px !important",
  },
  hitPredictorList: {
    position: "relative",
    display: "block",
    "& li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 15px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      boxShadow:
        "0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)",
      borderRadius: "10px",
      marginBottom: "8px",
      "& img": {
        width: "60px",
        height: "60px",
        maxWidth: "initial",
        borderRadius: "10px",
      },
      "& h4": {
        fontWeight: "600",
        fontSize: "16px",
        color: "rgba(0,0,0,0.9)",
      },
      "& p": {
        fontWeight: "400",
        fontSize: "14px",
        color: "rgba(0,0,0,0.9)",
      },
      "& a": {
        textDecoration: "none",
        color: "#B0B0B0",
        fontSize: "12px",
        color: "#E14084",
        "@media(max-width:480px)": {
          whiteSpace: "nowrap",
        },
      },
      "& strong": {
        position: "absolute",
        top: "5px",
        left: "5px",
        fontWeight: "700",
        fontSize: "20px",
        color: "#000",
        opacity: "0.2",
      },
    },
    "& li.active": {
      border: "1px solid #E14084",
      "& h4": {
        color: "#E14084",
      },
      "& strong": {
        opacity: "1",
      },
      "& a": {
        color: "#E14084",
      },
    },
  },
  playIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "25px !important",
    height: "25px !important",
  },
  playerContainer: {
    position: "relative",
    display: "flex",
    alignItems: "end",
    "& time": {
      fontSize: "10px",
      padding: "0 5px",
      whiteSpace: "nowrap",
      color: "#0F1E36",
      opacity: "0.5",
      position: "relative",
      top: "5px",
    },
    "& img": {
      width: "15px !important",
      height: "15px !important",
      borderRadius: "0 !important",
      marginRight: "5px",
    },
  },
  congratsMsg: {
    position: "relative",
    display: "block",
    padding: "10px 0",
    background: "rgba(84, 181, 187, 0.1)",
    border: "1px solid #4BAF55",
    borderRadius: "8px",
    color: "#48B16E",
    textAlign: "center",
  },
}));

const HitPredictor = ({
  message,
  setSelectedSong,
  playedSeconds,
  selectedSong = null,
  totalDuration = 0,
  isPlaying = false,
  pauseSong,
  playSong,
  setSongList,
  isMobile,
}) => {
  const [isPollEnded, setIsPollEnded] = useState(false);
  const [displayResult, setDisplayResult] = useState(false);
  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = useCountDown(message?.predictorEndDate);
  //   const isPollEnded = hasPollEnded(message?.createdAt, message?.pollEndDate);
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState([]);
  //   const [countSong, setCountSong] =useState(1);

  const { mutate: sendResponseToPredictor } = useMutation(
    (data) =>
      fetcher.post(`/v1/message/${data.messageId}/predictor-response`, {
        optionId: data.optionId,
      }),
    {
      onSuccess: (response) => {
        console.log("res", response);
      },
      onError: (error) => {
        console.log("could not respond", error);
      },
    }
  );

  useEffect(() => {
    if (message) {
      if (message?.predictorResponseOption) {
        setSelectedOption(
          message?.predictorResponseOption.map((item) => item?.optionId)
        );
      }
    }
  }, [message]);

  const BorderLinearProgress2 = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#E14084" : "#fff",
    },
  }));

  const addResponseToPredictor = (messageId, optionId) => {
    if (optionId) {
      let allreadyselectd = selectedOption?.filter((item) => item == optionId);
      if (allreadyselectd?.length > 0) {
        let allSelectd = [...selectedOption];
        const indexvalue = allSelectd.indexOf(optionId);
        if (indexvalue > -1) allSelectd.splice(indexvalue, 1);
        setSelectedOption(allSelectd);
        sendResponseToPredictor({ messageId, optionId });
      } else {
        setSelectedOption([...selectedOption, optionId]);
        sendResponseToPredictor({ messageId, optionId });
      }
    }
  };

  useEffect(() => {
    if (message) {
      setSongList(message?.predictorOptions);
      if (message?.predictorEndDate) {
        const today = new Date();
        const endsAt = new Date(message?.predictorEndDate);
        const todayInGmt = new Date(today.toUTCString());
        if (endsAt.getTime() - todayInGmt.getTime() < 0) {
          setIsPollEnded(true);
        } else {
          setIsPollEnded(false);
        }
      } else {
        setIsPollEnded(false);
      }

      // should display result
      if (message?.predictorResultDate) {
        const today = new Date();
        const endsAt = new Date(message?.predictorResultDate);
        const todayInGmt = new Date(today.toUTCString());

        if (endsAt.getTime() - todayInGmt.getTime() < 0) {
          setDisplayResult(true);
        } else {
          setDisplayResult(false);
        }
      } else {
        setDisplayResult(false);
      }
    }
  }, [message]);

  const getPlayPercentage = () => {
    if (totalDuration && playedSeconds) {
      let playedPercent = Math.floor((playedSeconds * 100) / totalDuration);

      return playedPercent;
    }
    return 0;
  };

  const getPlayedTimeInSeconds = (seconds) => {
    if (seconds < 60) {
      return "0:" + Math.floor(seconds).toString();
    } else {
      let timeInMinute = Math.floor(seconds / 60);
      let timeInSeconds = Math.floor(seconds % 60);
      if (timeInSeconds < 10)
        return timeInMinute.toString() + ":0" + timeInSeconds.toString();
      else return timeInMinute.toString() + ":" + timeInSeconds.toString();
    }
  };

  const getVotePercentage = (options, option) => {
    if (options.length && option) {
      const totalRespone = options.reduce(
        (sum, item) => (item?.responseCount ? sum + item?.responseCount : sum),
        0
      );
      if (totalRespone)
        return (
          ((option?.responseCount ? option?.responseCount : 0) / totalRespone) *
          100
        );
      else return 0;
    }
    return 0;
  };

  const isWinner = () => {
    if (message) {
      if (message?.predictorResponseOption) {
        let responseMatch = message.predictorOptions.filter(
          (item) =>
            item?.isCorrect && item?._id == message?.predictorResponseOption
        );
        if (responseMatch.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <>
      <Box>
        <Box className={classes.todayPoll}>
          {!displayResult && (
            <Typography
              component="p"
              style={{
                fontSize: "16px",
                lineHeight: "18px",
                fontWeight: "normal",
                fontWeight: "500",
              }}
            >
              🏆 Winners will be announced on{" "}
              {moment(message?.predictorResultDate).format("DD MMMM")}
            </Typography>
          )}

          {displayResult && isWinner() && (
            <Typography
              component="span"
              className={classes.congratsMsg}
              style={{
                margin: "10px 0 30px,",
                fontSize: "16px",
                wordBreak: "break-word",
              }}
            >
              <Box
                component="img"
                src="/images/home/confetti.png"
                width="18px"
              />{" "}
              Congratulations! You are the winner
            </Typography>
          )}

          <Typography
            component="span"
            style={{ fontSize: "16px", wordBreak: "break-word" }}
          >
            {" "}
            {message?.text}{" "}
          </Typography>
          {!isPollEnded ? (
            <List className={classes.hitPredictorList}>
              {message?.predictorOptions?.map((item, key) => {
                return (
                  <>
                    <ListItem
                      key={key}
                      className={
                        selectedOption.indexOf(item?._id) != -1 ? "active" : ""
                      }
                    >
                      <Box style={{ position: "relative" }}>
                        <Box
                          component="img"
                          width={"60px"}
                          height={"60px"}
                          src={`https://img.youtube.com/vi/${item?.youtubeId}/mqdefault.jpg`}
                        />

                        <Box
                          component="img"
                          src={
                            selectedSong?._id == item?._id && isPlaying
                              ? "/images/hitpredict/pause.svg"
                              : "/images/hitpredict/video.svg"
                          }
                          className={classes.playIcon}
                          alt="hitpredict video img"
                          sx={{
                            cursor: "pointer",
                            borderRadius: "0px !important",
                            background: "rgba(0,0,0,0.4)",
                          }}
                          onClick={() => {
                            if (selectedSong?._id == item?._id && isPlaying) {
                              pauseSong();
                            } else setSelectedSong(item);
                          }}
                        />
                      </Box>
                      <Box style={{ padding: "0 10px", width: "100%" }}>
                        <Typography
                          variant="h4"
                          style={{
                            fontSize: "16px !important",
                            wordBreak: "break-word",
                            color:
                              item?._id == selectedOption
                                ? "rgb(225, 64, 132,1)"
                                : "rgba(0, 0, 0, 0.9)",
                          }}
                        >
                          {item?.songName}
                        </Typography>
                        <Typography
                          component="p"
                          style={{ fontSize: "16px", wordBreak: "break-word" }}
                        >
                          {item?.singerName}
                        </Typography>

                        {selectedSong?._id == item?._id &&
                          item?.songType == "audio" && (
                            <Box className={classes.playerContainer}>
                              <Box
                                component="img"
                                src={
                                  isPlaying
                                    ? "/images/hitpredict/audio.gif"
                                    : "/images/musicPause.svg"
                                }
                                width="20px"
                                height="20px"
                              />
                              <BorderLinearProgress2
                                className={classes.musicPlayer}
                                variant="determinate"
                                value={getPlayPercentage()}
                              />
                              <time>
                                {getPlayedTimeInSeconds(playedSeconds)} / 3:33
                              </time>
                            </Box>
                          )}
                      </Box>

                      <Link
                        href="#"
                        // disabled={
                        //   !message?.hasResponedToPredictor && !selectedOption
                        // }
                        onClick={() => {
                          addResponseToPredictor(message?._id, item?._id);
                        }}
                      >
                        {selectedOption.indexOf(item?._id) != -1
                          ? "Selected"
                          : "Select"}
                      </Link>
                    </ListItem>
                  </>
                );
              })}
            </List>
          ) : (
            <>
              <List className={classes.hitPredictorList}>
                {message?.predictorOptions?.map((item, key) => {
                  return (
                    <>
                      <ListItem
                        key={key}
                        // className={item?.responseCount == 1 ? "active" : ""}
                        className={
                          selectedOption.indexOf(item?._id) != -1
                            ? "active"
                            : ""
                        }
                      >
                        <Box style={{ position: "relative" }}>
                          <Box
                            component="img"
                            src={`https://img.youtube.com/vi/${item?.youtubeId}/mqdefault.jpg`}
                          />

                          <Box
                            component="img"
                            src={
                              selectedSong?._id == item?._id && isPlaying
                                ? "/images/hitpredict/pause.svg"
                                : "/images/hitpredict/video.svg"
                            }
                            className={classes.playIcon}
                            alt="hitpredict video img"
                            sx={{
                              cursor: "pointer",
                              borderRadius: "0px !important",
                            }}
                            onClick={() => {
                              if (selectedSong?._id == item?._id && isPlaying) {
                                pauseSong();
                              } else setSelectedSong(item);
                            }}
                          />
                        </Box>
                        <Box style={{ padding: "0 10px", width: "100%" }}>
                          <Typography
                            variant="h4"
                            style={{
                              color: item?.isCorrect
                                ? "rgb(225, 64, 132,1)"
                                : "rgba(0, 0, 0, 0.9)",
                            }}
                          >
                            {item?.songName}
                          </Typography>
                          <Typography component="p">
                            {item?.singerName}
                          </Typography>

                          {selectedSong?._id == item?._id &&
                            item?.songType == "audio" && (
                              <Box className={classes.playerContainer}>
                                <Box
                                  component="img"
                                  src={
                                    isPlaying
                                      ? "/images/hitpredict/audio.gif"
                                      : "/images/musicPause.svg"
                                  }
                                  width="20px"
                                  height="20px"
                                />
                                <BorderLinearProgress2
                                  className={classes.musicPlayer}
                                  variant="determinate"
                                  value={getPlayPercentage()}
                                />
                                <time>
                                  {getPlayedTimeInSeconds(playedSeconds)} / 3:33
                                </time>
                              </Box>
                            )}
                        </Box>
                        {item?.isCorrect && (
                          <Box
                            component="img"
                            style={{ padding: "5px" }}
                            src="/images/hitpredict/stamp.svg"
                          />
                        )}
                        <Link
                          disabled={
                            !message?.hasResponedToPredictor && !selectedOption
                          }
                        >
                          <Typography
                            sx={{
                              fontSize: "14px !important",
                              lineHeight: "17px !important",
                              fontWeight: "600 !important",
                              color: item?.isCorrect
                                ? "#E14084 !important"
                                : "#000 !important",
                            }}
                          >
                            {getVotePercentage(
                              message?.predictorOptions,
                              item
                            ).toFixed(2)}
                            %
                          </Typography>
                        </Link>
                      </ListItem>
                    </>
                  );
                })}
              </List>
            </>
          )}

          {!isPollEnded && selectedOption ? (
            <>
              <Typography
                component="p"
                style={{
                  textAlign: "center",
                  lineHeight: "21px",
                  wordBreak: "break-word",
                  fontSize: "16px !important",
                }}
              >
                Thank you for the participation.
                <br />
                We will announce the winners soon. {isMobile && <br />}
              </Typography>
            </>
          ) : (
            <></>
          )}
          {!isPollEnded && (
            <Box>
              <Box
                sx={{
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  Predictor ends in{" "}
                </Typography>
              </Box>

              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {days}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Days
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {hours}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Hours
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {minutes}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Min
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {seconds}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Sec
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default HitPredictor;
